import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {BarrierefreiheitService} from '../../services/barrierefreiheit.service';

@Component({
  selector: 'barrierefreiheitTextanpassung',
  templateUrl: './barrierefreiheitTextanpassung.component.html',
  styleUrls: ['./barrierefreiheitTextanpassung.component.css'],
})

export class BarrierefreiheitTextanpassungComponent implements OnInit, OnDestroy {
  @Output() textGroesseAngepasst = new EventEmitter();
  public aktuellePx
  private subscribe

  constructor(
    private barrierefreiheitService: BarrierefreiheitService,
  ) { }

  ngOnInit() {
    this.subscribe = this.barrierefreiheitService.neuesForm.subscribe(result => {
      if (result) {
        this.aktuellePx = result.textGroesse
      } else {
        this.barrierefreiheitService.neuesForm.next(this.barrierefreiheitService.barriereEinstellungenAnzeigen('textGroesse'))
      }
    })
  }

  ngOnDestroy() {
    this.subscribe.unsubscribe()
  }

  public textAnpassen(){
    this.textGroesseAngepasst.emit({['textGroesse']: this.aktuellePx})
  }
}
